/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import cookie from "react-cookies";
import Select from "react-select";
import { apiUrl, adminlimit, clientheaderconfig } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import { showStatus, encodeValue, removeItem, showLoader, hideLoader, showAlert } from "../../Helpers/SettingHelper";
import Header from "..//Layout/Header";
import Topmenu from "..//Layout/Topmenu";
import Footer from "..//Layout/Footer";
import Pagenation from "../Layout/Pagenation";
import { format } from "date-fns";
var module = "client/holiday";
var moduleName = "Holiday";
var Parser = require("html-react-parser");
const enableSMSCampaign = cookie.load('enableSMSCampaign') ?? 'false';
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: this.props?.location?.pathname || '',
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      loading: true,
      name: "",
      status: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(1);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };

   removeItem(deleteID, e) {
    e.preventDefault();
      removeItem(deleteID, module, 'client', this.sateValChange, this.state.currentPage);
    }

  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }

  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (
      this.state.status !== null &&
      Object.keys(this.state.status).length > 0
    ) {
      addParams += "&status=" + this.state.status.value;
    }

    var params = {
      params: "limit=" + adminlimit + "&offset=" + offset + addParams,
      url: apiUrl + module,
      authType: "client",
    };
    this.props.getListData(params);
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }

  importHoliday() {
    $("#holidaymodal").modal("toggle");
  }

  confirmimportHoliday() {
    var formData = new FormData();
    var imagefile = document.querySelector("#holiday_file");
    if (imagefile.files.length === 0) {
      this.setState({ errorFile: true });
      return false;
    } else {
      this.setState({ errorFile: false });
    }

    showLoader("import_holiday");
    formData.append("holiday_file", imagefile.files[0]);
    axios
      .post(apiUrl + module + "/import", formData, {
        headers: {
          Authorization: `Bearer ${cookie.load("clientAccessToken")}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        $("#holidaymodal").modal("toggle");
        hideLoader("import_holiday");
        $("#holiday_file").val("");
        var errMsg = res.data.message;
        if (res.data.status === "success") {
          showAlert("Success", errMsg, "success", "No");
          this.loadList(1);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }).catch((e)=> {
        const msg = e?.message  ?? "Something went wrong, try again"
          console.log(e, 'eeeee')
          showAlert("Error", msg, "error", "No");
          $("#holidaymodal").modal("toggle");
          hideLoader("import_holiday");
      })
  }

  convertCampaign(ID, type) {
    showLoader(`${type}_${ID}`);
    axios
      .post(apiUrl + module + "/convert", { holidayID:ID, converType:type }, clientheaderconfig)
      .then((res) => {
        hideLoader(`${type}_${ID}`);
        var errMsg = res.data.message;
        if (res.data.status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.loadList(1);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }).catch((e)=> {
        showAlert("Error", "Something went wrong, try again", "error", "No");
      })
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"holiday"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-9 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                  <div className="col-lg-3 col-md-6 text-end">
                    <Link to={this.state.path + "/add"}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Add New
                      </button>
                    </Link>
                    &nbsp;
                    <button
                      type="button"
                      className="btn btn-outline-primary waves-effect"
                      onClick={this.importHoliday.bind(this)}
                    >
                      Import
                    </button>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        onChange={this.handleChangeText}
                        value={this.state.name}
                      />
                      <label htmlFor="name">Title</label>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline custm-select-box filter-select">
                      <Select
                        value={this.state.status}
                        onChange={this.handleSelectChange.bind(this, "status")}
                        placeholder="Select Status"
                        isClearable={true}
                        options={[
                          { value: "A", label: "Active" },
                          { value: "I", label: "Inactive" },
                        ]}
                      />
                      <label className="select-box-label">Status</label>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2">
                    <button
                      type="button"
                      className="btn btn-primary me-sm-3 me-1 waves-effect waves-light"
                      onClick={this.searchList.bind(this)}
                    >
                      Search
                    </button>
                    <button
                      type="reset"
                      className="btn btn-label-secondary waves-effect"
                      onClick={this.resetSearch.bind(this)}
                    >
                      Reset
                    </button>
                  </div>
                </div>

                <div className="card">
                  <div className="p-1 mt-4">
                    <table className="table">
                      <thead>
                        <tr>
                          <th className="text-nowrap">Holiday Name</th>
                          <th>Date</th>
                          <th>Description</th>
                         {/*  <th>SMS Description</th> */}
                          <th>Status</th>
                          <th>Actions</th>
                           {enableSMSCampaign==='true' &&
                          <th>Convert</th>
                           }
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={4} align="center">
                              <div
                                className="spinner-border spinner-border-lg text-primary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.listdata.length > 0 ? (
                          this.state.listdata.map((item, index) => {
                            var holidayCompanyID = item?.holidayCompanyID ?? '';
                            return (
                              <tr key={index}>
                                <td className="text-nowrap" valign="top">
                                  <strong>{item.holidayName}</strong>
                                </td>
                                <td className="text-nowrap"  valign="top">{(item.holidayDate!=='' && item.holidayDate!==null)?format(new Date(item.holidayDate), "yyyy-MM-dd"):''}</td>
                               {/*  <td  valign="top">{(item.holidayDescription!=="" && item.holidayDescription!==null)?Parser(item.holidayDescription):''}</td> */}
                                <td valign="top">{(item.holidaySMSDescription!=="" && item.holidaySMSDescription!==null)?Parser(item.holidaySMSDescription):''}</td>
                                <td valign="top">{showStatus(item.holidayStatus)}</td>
                                <td valign="top">
                                  {holidayCompanyID!=="" && holidayCompanyID!==null && (
                                    <div className="dropdown">
                                      <button
                                        type="button"
                                        className="btn p-0 dropdown-toggle hide-arrow"
                                        data-bs-toggle="dropdown"
                                      >
                                        <i className="mdi mdi-dots-horizontal"></i>
                                      </button>
                                      <div className="dropdown-menu">
                                        <Link
                                          to={
                                            this.state.path +
                                            "/edit/" +
                                            encodeValue(item._id)
                                          }
                                          className="dropdown-item"
                                        >
                                          <i className="mdi mdi-pencil-outline me-1"></i>
                                          Edit
                                        </Link>
                                        <a
                                          className="dropdown-item"
                                          href="/"
                                          onClick={this.removeItem.bind(
                                            this,
                                            encodeValue(item._id)
                                          )}
                                        >
                                          <i className="mdi mdi-trash-can-outline me-1"></i>
                                          Delete
                                        </a>
                                      </div>
                                    </div>
                                  )}
                                </td>
                                 {enableSMSCampaign==='true' &&
                                <td valign="top" className="text-nowrap">
                                  {item.generateEmailCampaign==="No" && (
                                    <>
                                    <button
                                      type="button"
                                      className="btn btn-info waves-effect waves-light"
                                      onClick={this.convertCampaign.bind(this, item._id, 'email')} id={`email_${item._id}`}
                                    >
                                      Generate To Email Campaign
                                    </button><br/>
                                    </>
                                  )}
                                  {item.generateSMSCampaign==="No" && (
                                    <button
                                      type="button"
                                      className="btn btn-primary waves-effect waves-light mt-2"
                                      onClick={this.convertCampaign.bind(this, item._id, 'sms')} id={`sms_${item._id}`}
                                    >
                                      Generate To SMS Campaign
                                    </button>
                                  )}
                                </td>
                          }
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={8}>
                              No {moduleName} Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <div
          className="modal fade"
          id="holidaymodal"
          aria-hidden="true"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
        >
          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Import Holiday</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className=" mb-4">
                  <div className="card-body mt-3">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline mb-4">
                          <div className="mb-3">
                            <label htmlFor="formFile" className="form-label">
                              Import Holiday File
                            </label>
                            <input
                              className="form-control"
                              type="file"
                              id="holiday_file"
                              name="holiday_file"
                            />
                            {this.state.errorFile === true && (
                              <span className="error">
                                This field is required
                              </span>
                            )}
                          </div>
                        </div>
                        <a href="/files/holiday.csv">Downlaod Sample File</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-label-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  id="import_holiday"
                  onClick={this.confirmimportHoliday.bind(this)}
                >
                  Import
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  var listdataStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    listdataStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
